import * as React from 'react'

import Svg, { G, Mask, Path, SvgProps } from 'react-native-svg'

const Checkbox = (props: SvgProps) => (
  <Svg width={18} height={18} viewBox="0 0 18 18" fill="none" {...props}>
    <Path
      d="M0 4C0 1.79086 1.79086 0 4 0H14C16.2091 0 18 1.79086 18 4V14C18 16.2092 16.2091 18 14 18H4C1.79086 18 0 16.2092 0 14V4Z"
      fill="white"
    />
    <G opacity={0.32}>
      <Mask id="path-2-inside-1_228_5986" fill="white">
        <Path d="M0 4C0 1.79086 1.79086 0 4 0H14C16.2091 0 18 1.79086 18 4V14C18 16.2091 16.2091 18 14 18H4C1.79086 18 0 16.2091 0 14V4Z" />
      </Mask>
      <Path
        d="M4 0V1.5H14V0V-1.5H4V0ZM18 4H16.5V14H18H19.5V4H18ZM14 18V16.5H4V18V19.5H14V18ZM0 14H1.5V4H0H-1.5V14H0ZM4 18V16.5C2.61929 16.5 1.5 15.3807 1.5 14H0H-1.5C-1.5 17.0376 0.962434 19.5 4 19.5V18ZM18 14H16.5C16.5 15.3807 15.3807 16.5 14 16.5V18V19.5C17.0376 19.5 19.5 17.0376 19.5 14H18ZM14 0V1.5C15.3807 1.5 16.5 2.61929 16.5 4H18H19.5C19.5 0.962434 17.0376 -1.5 14 -1.5V0ZM4 0V-1.5C0.962434 -1.5 -1.5 0.962434 -1.5 4H0H1.5C1.5 2.61929 2.61929 1.5 4 1.5V0Z"
        fill="#1E1A14"
        mask="url(#path-2-inside-1_228_5986)"
      />
    </G>
  </Svg>
)
export default Checkbox
